import { COMMON_ASSETS_PATH } from "@ipru-common/constants/SiteConstants";
let config = null;
let configPromise = null;
const defaultConfig = {
  API: {
    JOINTLIFE: {
      BASE: "https://buyuat.iprulifeinsurance.com/digiuatnew",
    },
    SUPER_IPS: {
      BASE: "https://buyuat.iprulifeinsurance.com/digiuatnew",
    },
    I_WISH: {
      BASE: "https://buyuat.iprulifeinsurance.com/digiuatnew",
    },
    SOL_JOINTLIFE: {
      BASE: `https://buyuat.iprulifeinsurance.com/digiuatnew`,
    },
    SOL_SUPER_IPS: {
      BASE: "https://buyuat.iprulifeinsurance.com/digiuatnew",
    },
  },
  TRANSLATION_FILE_BASE: "",
  LEAD_PAGE_NAME_PREFIX: "- AEM UAT",
  THANK_YOU_PAGE: "https://aemuat.icicilife.com/testing/thank-you-r.html",
  LIGO_CHAT: "https://www.icicilife.com/testing/Common/ligochatbot-shared-bkp/index.html",
  pageURL: "https://www.icicilife.com/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
  pageURL_iprime:
    "https://www.icicilife.com/aempoc/aem-iprime-preprod/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
  IPS_URL:
    "https://www.icicilife.com/aempoc/aem-ipsplus-artifact/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
};

export const appConfig = async () => {
  if (config) {
    return config;
  }

  if (configPromise) {
    return configPromise;
  }

  configPromise = (async () => {
    try {
      const fetchedData = await fetch(`${COMMON_ASSETS_PATH}/appconfig/development.json?v=${Date.now()}`).then(
        (response) => response.json()
      );

      config = {
        ...defaultConfig,
        ...fetchedData,
        API: {
          ...defaultConfig.API,
          ...fetchedData.API,
        },
      };

      return config;
    } catch (error) {
      console.error("Failed to fetch app config:", error);

      config = defaultConfig;
      return config;
    }
  })();

  return configPromise;
};

export const APP_ENV_CONFIG = {
  JOINTLIFE: `${defaultConfig.API.JOINTLIFE.BASE}/PartnerIntegration.htm`,
  SUPER_IPS: `${defaultConfig.API.SUPER_IPS.BASE}/PartnerIntegration.htm`,
  I_WISH: `${defaultConfig.API.I_WISH.BASE}/PartnerIntegration.htm`,
  TRANSLATION_FILE_BASE: defaultConfig.TRANSLATION_FILE_BASE,
  LEAD_PAGE_NAME_PREFIX: defaultConfig.LEAD_PAGE_NAME_PREFIX,
  LIGO_CHAT: defaultConfig.LIGO_CHAT,
  THANK_YOU_PAGE: defaultConfig.THANK_YOU_PAGE,
  pageURL: defaultConfig.pageURL,
  pageURL_iprime: defaultConfig.pageURL_iprime,
  IPS_URL: defaultConfig.IPS_URL,
  SOL_JOINTLIFE: `${defaultConfig.API.SOL_JOINTLIFE.BASE}/PartnerIntegration.htm`,
  SOL_SUPER_IPS: `${defaultConfig.API.SOL_SUPER_IPS.BASE}/PartnerIntegration.htm`,
};

export default appConfig;
